import React from 'react';
import Tabs from '../../../../components/Tabs/Tabs';
import BrandDetailInfoSection from '../../../brand/detail/info/BrandDetailInfoSection';
import BrandDetailStatisticSection from '../../../brand/detail/statistic/BrandDetailStatisticSection';
import BrandDetailOrderBalanceSection from '../../../brand/detail/orderBalance/BrandDetailOrderBalanceSection';
import BrandDetailProductSection from '../../../brand/detail/product/BrandDetailProductSection';
import BrandDetailNoticeProductSection from '../../../brand/detail/noticeProduct/BrandDetailNoticeProductSection';
import BrandDetailProductRegisterSection from '../productRegister/BrandDetailProductRegisterSection';
import { useCurrentTab } from '../../../../hooks/common/useCurrentTab';
import { useIsBrandRequestJoin } from '../../../../hooks/brand/detail/useIsBrandRequestJoin';
import './BrandDetailWrap.scss';

const BrandDetailWrap = (props) => {
  const isBrandRequestJoin = useIsBrandRequestJoin();
  const { currentTabKey, setTabKey } = useCurrentTab();
  const { storeId, setData } = props;

  return (
    <div className="brand-detail-wrap">
      {/* 브랜드 상세 */}
      <Tabs
        activeKey={currentTabKey}
        onChange={(tabKey) => setTabKey(tabKey)}
        list={[
          {
            title: '브랜드 정보',
            content: <BrandDetailInfoSection storeId={storeId} setData={setData} />,
          },
          {
            title: '통계 정보',
            disabled: isBrandRequestJoin,
            content: <BrandDetailStatisticSection storeId={storeId} setData={setData} />,
          },
          {
            title: '주문/정산 정보',
            disabled: isBrandRequestJoin,
            content: <BrandDetailOrderBalanceSection storeId={storeId} />,
          },
          {
            title: '상품 정보',
            disabled: isBrandRequestJoin,
            content: <BrandDetailProductSection storeId={storeId} />,
          },
          {
            title: '공지사항 정보',
            disabled: isBrandRequestJoin,
            content: <BrandDetailNoticeProductSection storeId={storeId} />,
          },
          {
            title: '상품등록 정보',
            disabled: isBrandRequestJoin,
            content: <BrandDetailProductRegisterSection storeId={storeId} />,
          },
        ]}
      />
    </div>
  );
};

export default BrandDetailWrap;
